module.exports = __webpack_public_path__ + "img/wide.4fb68c5a.jpg";